import { List } from "antd";

import { BaseListProps } from "./types";

const BaseList = <T,>({ ...props }: BaseListProps<T>) => {
  return <List {...props} />;
};

export default BaseList;
